const styles = ({ palette, screenSizes, spacing }) => ({
  background: palette.background,
  boxShadow: '0 0 6px rgba(0,0,0,0.2)',
  padding: [spacing.sm, 10],
  textAlign: 'center',
  zIndex: 2,
  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
    padding: '0.5em',
  },
});

export default styles;
